module.exports = __webpack_public_path__ + "img/slide2_img2.cf0c2f37.png";